export default function ExportJobNoFormDataDisclaimer() {
  return (
    <p className="text-sm">
      Patient has not yet completed their export customization form. There is no
      additional metadata to display at this time.
    </p>
  );
}
